// extracted by mini-css-extract-plugin
export default {"kampanjeBox":"KampanjeTilbud_kampanjeBox__Owcpf","part1":"KampanjeTilbud_part1__MVwwn","part2":"KampanjeTilbud_part2__L5kZF","tittel":"KampanjeTilbud_tittel__kYcKI"};